if( window.console == null ){
    window.console = {
        log: function (p) {},
    };
}

var 
    _body,
    _window
;

var sebrae_FN = function(){

    sebrae = this;
    sebrae.init();

};

(function($){

    sebrae_FN.prototype = {

        percurseSameWay : 0,
        lastScrollTop : 0,
        lastSent : 'up',
        
        init: function(){

            _body = $( 'body' );
            _window = $( window );

            // Header elements
            sebrae.$header = $( 'body > header' ).first();
            sebrae.$nav = $( 'body > nav' ).first();

            // Função de resize da janela do browser ( Define qual o viewport )
            sebrae.resizing();
            window.onresize = sebrae.resizing;

            // Control of page scroll
            sebrae.scrolling();
            _window.on( 'scroll', sebrae.scrolling );

            // Userbar
            sebrae.userBar.init();

            // Splash
            sebrae.bindSplash();

            // Init modal events
            sebrae.modal.init();

            // General functions
            sebrae.general();

            // Copy link
            sebrae.copyLinkBind();

            // File fields
            sebrae.fileFields();

        },

        // Properties of Class
        properties: {
            timeEffects: 400, // Tempo para os efeitos
            device: 'desktop', // Device default
            loading: false,
            userbars: false,
        },

        // File fields
        fileFields : () => {
            
            $( 'input:file' ).not( '.ready' ).each(function(){
                $( this ).wrap('<div class="j-custom-filefield-holder"></div>' );
            }).addClass('ready');

        },
        
        bindSplash : function(){

            // Elements
            const 
                splash = document.querySelector( 'section.splash' ),
                close = document.querySelector( 'section.splash > div > div > button.close' ),
                cookie = Cookie.get( 'splash-closed' ),
                views = ( cookie === '' ) ? 0 : parseInt( cookie );
            ;

            // Not exists
            if( splash === null || views >= 4 ) return true;

            // Show
            splash.classList.add( 'showing' );
            sebrae.lockScroll();

            // Click out
            splash.addEventListener( 'click', function( event ){
                if( event.target.classList.contains( 'splash' ) ){
                    sebrae.closeSplash( splash, views );
                }
            });

            // Close button
            close.addEventListener( 'click', function(){
                sebrae.closeSplash( splash, views );
            });

        },

        closeSplash : function( splash, views ){
            splash.classList.remove( 'showing' );
            sebrae.unlockScroll();
            Cookie.set( 'splash-closed', ( views + 1 ) );
        },

        copyLinkBind : async () => {

            $( 'body' ).on( 'click', 'button.copy-link', async function( event ){

                event.preventDefault();

                this.$ = this.$ || $( this );

                let data = this.$.data( 'copyLink' );
                if( data === undefined ){

                    data = {
                        self: this,
                        $ : this.$,
                        text : this.$.children( 'strong' ).text(),
                        $text : this.$.children( 'span' ),
                        timeout : false
                    };
                    data.copyText = data.$text.text();

                    this.$.data( 'copyLink', data );
                    
                }

                const copyed = await sebrae.copyText( data );
                if( copyed ){
                    
                    data.$.addClass( 'success' );
                    data.$text.text( 'Link copiado!' );
                    
                    if( data.timeout ) clearTimeout( data.timeout );
                    data.timeout = setTimeout( () => {

                         data.$.removeClass( 'success' );
                         data.$text.text( data.copyText );
                    
                    }, 3000 );

                }

            });
        },

        copyText : async function( data ){
            
            try {
                await navigator.clipboard.writeText( data.text );
                return true;
            } 
            catch( err ){
                console.error( 'Failed to copy: ', err );
                return false;
            }
  
        },
        
        // Função de resize da janela do browser ( Define qual o viewport )
        resizing: function () {
            
            var _wWidth = _window.outerWidth();

            // Define qual o viewport
            if( _wWidth < 768 ){
                sebrae.properties.device = 'smartphone';
            }
            else if ( _wWidth >= 768 && _wWidth <= 1279 ){
                sebrae.properties.device = 'tablet';
            }
            else { 
                sebrae.properties.device = 'desktop';
            }

            if ( sebrae.properties.device === 'desktop' ){
                _body
                    .removeClass( 'tablet' )
                    .removeClass( 'mobile' )
                    .addClass( 'desktop' )
                ;
            } 
            else if( sebrae.properties.device === 'tablet' ){
                _body
                    .removeClass( 'desktop' )
                    .removeClass( 'mobile' )
                    .addClass( 'tablet' )
                ;
            } 
            else if( sebrae.properties.device === 'smartphone' ){
                _body
                    .removeClass( 'desktop' )
                    .removeClass( 'tablet' )
                    .addClass( 'mobile' )
                ;
            }
        
        },

        userBar : {

            $ : false,

            init : function(){

                this.$  = this.$ || $( '.userbar' );
                if( !this.$.length ) return true;

                this.bind();

            },

            bind : function(){

                _body.on( 'click', '.userbar .botao', function( e ){
                
                    e.preventDefault();
                
                    this.$ = this.$ || $( this );
                    this.$p = this.$p || this.$.parent();

                    if( this.$p.hasClass( 'opened' ) ){
                        sebrae.userBar.close();
                    }
                    else {
                        sebrae.userBar.open( this );
                    }
                
                });
                
                // General click
                _body.on( 'click', function( e ){
                    
                    e.target.$ = e.target.$ || $( e.target );
                    e.target.$p = e.target.$p || e.target.$.parents( '.userbar' );

                    if( !e.target.$p.length && !e.target.$.hasClass( '.userbar' ) ){
                        sebrae.userBar.close();
                    }

                });

                // With menu
                _body.on( 'menuToggle', function(e){
                    sebrae.userBar.close();
                });

            },

            open : function( el ){

                el.$ = el.$ || $( el );
                el.$p = el.$p || el.$.parent();
                el.$m = el.$m || el.$p.find( '.menu' );

                sebrae.userBar.close();

                el.$p.addClass( 'opened' );
                el.$m.stop( true, true ).fadeIn();

            },

            close : function(){

                if( !this.$ || !this.$.length ) return true;

                this.$.each(function(){
                    this.$ = this.$ || $( this );
                    this.$
                        .removeClass( 'opened' )
                        .find( '.menu' )
                        .stop( true, true )
                        .fadeOut()
                    ;
                });                

            }

        },

        // Controla o scroll da página
        scrolling: function( e ){

            const 

                // Vertical scroll position
                scrollTop = ( window.pageYOffset || document.documentElement.scrollTop ) - ( document.documentElement.clientTop || 0 ),
            
                // Direction of scroll
                dir = scrollTop >= sebrae.lastScrollTop ? 'up' : 'down',
            
                // Full header height
                headerHeight = sebrae.$header.outerHeight()
            ;

            // Percurse
            if( dir === sebrae.lastSent ){
                sebrae.percurseSameWay++;
            }
            else {
                sebrae.percurseSameWay = 0;
            }

            // Hide menu if to down
            if( dir === 'down' && sebrae.percurseSameWay > 10 ){
                sebrae.userBar.close();
            }

            // If scroll hide header, floating him
            if( scrollTop > headerHeight && dir === 'down' ){
                sebrae.$nav.addClass( 'active' );
            }
            // When came to top scroll, fix menu
            else if( sebrae.percurseSameWay > 10 || scrollTop === 0 ) {
                sebrae.$nav.removeClass( 'active' );
            }

            // Keep last proprierts
            sebrae.lastScrollTop = _window.scrollTop();
            sebrae.lastSent = dir;
        
        },

        // Funções gerais de todo o site
        general: function(){

            // Form cadastro
            _body.on( 'onChangeStep', 'form#psjuser', function( e, data, step ){
                sebrae.signingLoginText = sebrae.signingLoginText || $( '.cadastro-login-text' );
                if( step === 'passo1' ){
                    sebrae.signingLoginText.fadeIn( 200 );
                }
                else {
                    sebrae.signingLoginText.fadeOut( 100 );
                }
            });

            // Home categories
            if( window.innerWidth < 640 ){
                const $categs = $( '#categorias' );
                if( $categs.length ){
                    $categs.find( '.categories' ).slick({
                        dots: true,
                        infinite: false
                    });
                }

            }

            // Accordion
            var $list = $( '#list' );
            if( $list.length ){

                $( 'div.center > ul > li > button', $list ).on('click', function(){
                    
                    const _this = $( this ),
                    parent = _this.parent();

                    if( parent.hasClass( 'active' ) ){
                        $( '> div', parent ).slideUp( sebrae.properties.timeEffects );
                        parent.removeClass('active');
                    } 
                    else {

                        $( '> div', parent ).slideDown( sebrae.properties.timeEffects );
                        parent.addClass( 'active' );

                        parent
                            .siblings( '.active' )
                            .removeClass( 'active' )
                            .find( '> div' )
                            .slideUp( sebrae.properties.timeEffects )
                        ;
                    }
                    
                });

            }

        },

        // Lock scroll
        lockScroll : function(){
            $('html,body').addClass( 'lockscroll' );
        },

        // Unlock scroll
        unlockScroll : function(){
            $('html,body').removeClass( 'lockscroll' );
        },

        modal: {
            
            /*
             * INIT - Bind events
             */
            init: function () {

                $('div.modal, div.modal .bt-close').on('click', function(e){
        
                    const _this = $(e.target),
                    className = String(
                        _this.parents('div.modal:first').length
                            ? _this.parents('div.modal:first').attr('class')
                            : _this.attr('class')
                    ).replace(' ', '.');

                    if (
                        _this.is('.bt-close') ||
                        _this.is('.bt-close i') ||
                        _this.is('div.modal')
                    ){
                        sebrae.modal.close(className);
                    }
                
                });

                $(document).on( 'keyup', function( evt ){
                    if (evt.keyCode == 27) {
                        sebrae.modal.close();
                    }
                });

                $( '.btn-open-modal' ).on( 'click', function () {
                    const _this = $(this);
                    if (_this.data('id').length){
                        sebrae.modal.toggleModal(_this.data('id'));
                    }

                    return false;
                });
            },

            /*
            * Close
            */
            close: function( className ){
                $( 'div.' + ( typeof className !== 'undefined' ? className : 'modal' ) ).fadeOut( sebrae.properties.timeEffects, function(){
                    _body.removeClass( 'modal-open' );
                });
            },

            /*
            * Open/Close modal
            */
            toggleModal: function (name) {
                
                const modal = $( 'div.modal.' + name );

                if( modal.is( ':visible' ) ){
                    sebrae.modal.close();
                }
                else {
                    sebrae.modal.close();
                    modal.fadeIn( sebrae.properties.timeEffects, function(){
                        _body.addClass( 'modal-open' );
                    });
                }
            },
        },
    };

    window.addEventListener( 'DOMContentLoaded', () => {
        sebrae = new sebrae_FN();
    });
  
})(jQuery);
